module.exports = __webpack_public_path__ + "static/media/21ECLAC44.95a58a86.jpg";